const ROUTES = {
  "/": {
    "name": "HomePageA5a63df222454e98A2c778283457aa26",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPage2b5e4892Cda747e9A6882f74eca39265",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages1359e263160a431480fe8be85f55c3fb",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage0c86bd6f6f0c45f8B8ba822f0954652a",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage5dce7bd7F69d4f2a90a2A49d4ea3900a",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;